import { render, staticRenderFns } from "./SectionBase.vue?vue&type=template&id=2bc18f74&scoped=true&"
import script from "./SectionBase.vue?vue&type=script&lang=js&"
export * from "./SectionBase.vue?vue&type=script&lang=js&"
import style0 from "./SectionBase.vue?vue&type=style&index=0&id=2bc18f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc18f74",
  null
  
)

export default component.exports